<template>
  <div style="padding: 5px;">
    <a-card>
      <div style="text-align: right;">
        <span
          class="ant-descriptions-title"
          style="float: left; margin-top: 5px;"
        >
          <a-icon type="tags" /> List department
        </span>

        <a-input
          placeholder="Search department..."
          style="max-width: 400px; width: 100%; margin-right: 5px;"
          @change="onFilter"
          v-model="filter.query"
        />
        <a-button-group style="margin-right: 5px;">
          <a-button
            @click="onChangeStatusFilter()"
            :type="!filter.status ? 'primary' : ''"
          >
            All
          </a-button>
          <a-button
            @click="onChangeStatusFilter('ACTIVE')"
            :type="filter.status === 'ACTIVE' ? 'primary' : ''"
          >
            Active
          </a-button>
          <a-button
            @click="onChangeStatusFilter('DEACTIVE')"
            :type="filter.status === 'DEACTIVE' ? 'primary' : ''"
          >
            Deactive
          </a-button>
        </a-button-group>
        <a-button type="primary" @click="visibleAddDepartment = true">
          <a-icon type="plus" /> Add New
        </a-button>
      </div>

      <a-table
        :loading="loading"
        size="small"
        :columns="columnDepartment"
        :data-source="listDepartment"
        rowKey="id"
        style="margin-top: 5px;"
        :pagination="{
          current: currentPage,
          onChange: (page) => {
            this.currentPage = page;
          },
          pageSize: limit,
        }"
      >
        <div slot="footer">
          <a-button
            :loading="loading"
            type="link"
            @click="onPagination"
            :disabled="!isPagination"
          >
            <a-icon type="reload" /> Load more
          </a-button>
        </div>
        <div slot="stt" slot-scope="text, record, index">
          {{ index + 1 }}
        </div>

        <div slot="name" slot-scope="text, record">
          <a @click="showDrawerUpdateDepartment(record)"> {{ text }}</a>
        </div>

        <div slot="status" slot-scope="text, record">
          <p v-if="record.status === 'ACTIVE'">
            <a-icon type="check" style="marginleft: 5px; color: #52c419;" />
          </p>
        </div>
        <!--
        <div slot="managers" slot-scope="text, record">
          {{ record }}
          {{ record.fullname || record.email }}
        </div> -->

        <div slot="createdAt" slot-scope="text, record">
          <p>
            {{ record.createdAt | formatDateHour }}
          </p>
        </div>

        <div slot="updatedAt" slot-scope="text, record">
          <p>
            {{ record.updatedAt | formatDateHour }}
          </p>
        </div>

        <div slot="action" slot-scope="text, record">
          <a-button
            icon="edit"
            @click="showDrawerUpdateDepartment(record)"
            class="icon-update"
          >
            Edit
          </a-button>
        </div>
      </a-table>
      <a-drawer
        v-if="visibleAddDepartment"
        title="Add new"
        placement="right"
        :visible="visibleAddDepartment"
        @close="visibleAddDepartment = false"
        :width="600"
        :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
      >
        <AddDepartment
          :closeDrawerAddDepartment="() => (visibleAddDepartment = false)"
          :createdDepartmentUpdateOnView="createdDepartmentUpdateOnView"
        />
      </a-drawer>

      <a-drawer
        :width="625"
        v-if="visibleUpdateDepartment"
        title="Edit"
        placement="right"
        :visible="visibleUpdateDepartment"
        @close="closeDrawerUpdateDepartment"
        :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
      >
        <UpdateDepartment
          :closeDrawerUpdateDepartment="closeDrawerUpdateDepartment"
          :idDepartment="idDepartment"
          :updateDepartmentOnView="updateDepartmentOnView"
          :deleteDepartmentOnView="deleteDepartmentOnView"
        />
      </a-drawer>
    </a-card>
  </div>
</template>
<script>
import AddDepartment from "./components/addDepartment";
import UpdateDepartment from "./components/updateDepartment";
import getQuery from "../data/getData";
import { columnDepartment } from "../Constants/dataColumns";
import {
  updateForCreated,
  updateForUpdated,
  updateForDeleted,
} from "@/services/updateOnViewConfig";
import debounce from "lodash/debounce";
const limit = 10;
const startPage = 1;
const defaultFilter = { query: "", status: "ACTIVE" };
export default {
  components: {
    AddDepartment,
    UpdateDepartment,
  },
  data() {
    this.onFilter = debounce(this.onFilter, 500);
    return {
      limit,
      idDepartment: null,
      visibleAddDepartment: false,
      visibleUpdateDepartment: false,
      loading: true,
      columnDepartment,
      listDepartment: [],
      filter: defaultFilter,
      currentPage: startPage,
      totalPage: startPage,
      isPagination: true,
    };
  },
  methods: {
    showDrawerUpdateDepartment(record) {
      this.idDepartment = record.id;
      this.visibleUpdateDepartment = true;
    },
    updateDepartmentOnView(item) {
      this.listDepartment = updateForUpdated(this.listDepartment, item);
    },
    createdDepartmentUpdateOnView(item) {
      this.listDepartment = updateForCreated({
        list: this.listDepartment,
        item,
        limit,
        currentPage: this.currentPage,
      });
    },
    deleteDepartmentOnView(item) {
      this.listDepartment = updateForDeleted(this.listDepartment, item);
    },
    closeDrawerUpdateDepartment(department) {
      this.visibleUpdateDepartment = false;
    },
    goToListDepartment(record) {
      this.$router.push({
        name: "updateDepartment",
        params: { idDepartment: record.id },
      });
    },
    getAllDepartment(flag) {
      this.loading = true;
      this.$apollo
        .query({
          query: getQuery.queryGetAllDepartment,
          variables: {
            status: this.filter.status,
            limit,
            page: this.totalPage,
            query: this.filter.query,
          },
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          if (data?.getAllDepartment?.length >= 0) {
            if (flag === "FILTER") {
              this.listDepartment = [...data.getAllDepartment];
            } else if (flag === "PAGINATION") {
              this.listDepartment = this.listDepartment.concat([
                ...data.getAllDepartment,
              ]);
            } else {
              this.listDepartment = [...data.getAllDepartment];
            }
            // check is pagniation
            if (data.getAllDepartment.length < limit) {
              this.isPagination = false;
            } else {
              this.isPagination = true;
            }
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log("Không lấy được danh sách phòng ban", error);
          this.loading = false;
        });
    },
    onChangeStatusFilter(status) {
      this.$set(this.filter, "status", status || undefined);
      this.onFilter();
    },
    onFilter() {
      this.currentPage = startPage;
      this.totalPage = startPage;
      this.getAllDepartment("FILTER");
    },
    onPagination() {
      if (this.isPagination) {
        this.totalPage += 1;
        this.currentPage = this.totalPage;
        this.getAllDepartment("PAGINATION");
      }
    },
  },
  created() {
    this.getAllDepartment();
  },
};
</script>
